import Query from "../utils/Query";
import Server from "../server";

export default class UserService {

	static me() {
		return Query.get('/users/me?fields=*,avatar.private_hash,wallpaper.private_hash,role.name,language.language_id.english_title,language.language_id.id,language.id');
	}

	static get(id) {
		return Query.get('/users/' + id + '?fields=*,avatar.private_hash,wallpaper.private_hash,role.name,language.language_id.english_title,language.language_id.id,language.id,last_access_on');
	}

	static register(email, password) {
		return Query.post('/custom/register', {
			email: email,
			password: password,
		});
	}

	static forgotPassword(email) {
		return Query.post('/custom/reset-password', {
			email: email,
		});
	}

	static resetPassword(token, password) {
		return Query.post('/auth/password/reset', {
			password: password,
			token: token,
		});
	}

	static verifyResetPasswordToken(token) {
		return Query.get('/custom/verify-token/' + token);
	}

	static activate(token) {
		return Query.get('/custom/activate-user/' + token);
	}

	static resendActivation(lookup) {
		return Query.get('/custom/resend-activation/' + lookup);
	}

	static resendActivationLost(email) {
		return Query.post('/users/resend-activation-lost', {
			email: email
		});
	}

	static setPassword(email, actual, password) {
		return Query.post('/custom/set-password', {
			email: email,
			actual: actual,
			password: password
		});
	}

	static loggedSetPassword(password) {
		return Query.post('/custom/user/logged-set-password', {
			password: password
		});
	}

	static update(id, data) {
		return Query.patch('/users/' + id + '?fields=*,avatar.private_hash,wallpaper.private_hash,role.name,language.language_id.english_title,language.language_id.id,language.id', data);
	}

	static updateWsToken(data) {
		return Query.post('/custom/user/update-ws-token', data);
	}
}
